import { DeleteAllOrdersService } from 'application/services/delete-all-orders'
import { api } from 'infra/adapters/http-client-adapter'

export const handleDeleteAllOrders = new DeleteAllOrdersService(api)
